import type { FilterItem } from '@ctw/shared/components/filter-bar/filter-bar-types';
import { faClipboardCheck } from '@fortawesome/pro-duotone-svg-icons';

export const RiskGapFilters: Array<FilterItem> = [
  {
    key: 'type',
    type: 'checkbox',
    icon: faClipboardCheck,
    display: 'Type',
    values: ['recapture', 'suspect'],
  },
];
